import React, { Component } from 'react'
import { JointClassComponent } from '.'
import { connect } from 'react-redux'
import { SchoolInformationActions } from '../../../../../../store'
import { DialogComponentUtil } from '..'
import lodashUtil from 'lodash';
import { toast } from 'react-toastify';
import * as StringReplacer from '../../../../../../i18n/StringReplacer'
import { ConstraintsAndPreferences, CalculateUtil } from '..';
import { UnjoinClassUtil } from '../unjoinClasses'

class JointClassContainer extends Component {
	constructor(props) {
		super(props)
		let cellData = this.props.dataTableMap.get(this.props.cellCode);
		let jointClasses = undefined
		if (cellData.elective !== undefined) {
			jointClasses = {
				electiveName: cellData.elective.name,
				electiveId: cellData.elective._id,
			}
		} else if (cellData.subject !== undefined) {
			jointClasses = {
				subjectId: cellData.subject._id,
				subjectName: cellData.subject.name,
				subjectCode: cellData.subject.code,
			}
		}
		this.state = {
			jointClasses: jointClasses,
			keyArray: [],
			gradeDetails: DialogComponentUtil.createGreadeDeatailsFromKeys(this.props),
			toggle: true,
		}
	}

	onClickOfSave = async () => {
		const i18n = this.props.i18n
		let jointClassExists = this.jointClassValidation();
		if (jointClassExists === false) {
			if (this.props.keys.length <= 1) {
				toast(i18n.jointClassConstraints.selectMin2Groups);
			} else {
				//constructing the joint class object here.
				let jointClasses = { ...this.state.jointClasses };
				jointClasses.gradeDetails = this.state.gradeDetails;
				jointClasses.bgColor = this.getRandomColor();


				let tempActiveSchool = JSON.parse(JSON.stringify(this.props.activeSchool))
				let scheduleConstraintsObj = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex]
				this.deletingPreviouslySavedRules(scheduleConstraintsObj);
				if (lodashUtil.isEmpty(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex])) {
					tempActiveSchool.schedule_constraints = [
						{ jointClasses: [] }
					]
					tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses.push(jointClasses)
				} else {
					tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses.push(jointClasses)

				}
				this.setState({ keyArray: this.props.keys })

				//await is used for the data to be saved in the data base and then access the activeSchool information to attach the data to the respective cell.
				tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex] = await CalculateUtil.calculateConstraintsAndPreference(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex],
					ConstraintsAndPreferences.Constants.JOINT_CLASSES)

				await this.props.updateDialogSave(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex]);
				await this.props.applyChangesMethod();
				//to attach the data to the cell using keys
				for (let i = 0; i < this.state.keyArray.length; i++) {
					let key = this.state.keyArray[i]
					let db_jointClasses = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses
					let jointClass = db_jointClasses[db_jointClasses.length - 1];
					this.props.dataTableMap.get(key).jointClass = jointClass;
					this.props.dataTableMap.get(key).bgColor = jointClass.bgColor;
				}
			}
		}
		this.props.handleCloseForDialog();
		this.props.handleClose();

	}

	deletingPreviouslySavedRules = (scheduleConstraintsObj) => {
		let keys = this.props.keys
		let dataTableMap = this.props.dataTableMap
		let gradeArray = []
		for (let i = 0; i < keys.length; i++) {
			let key = keys[i]
			let dataObj = dataTableMap.get(key)
			UnjoinClassUtil.deletingRules(scheduleConstraintsObj, dataObj)

			// deleting the grade Obj
			if (!gradeArray.includes(dataObj.grade)) {
				gradeArray.push(dataObj.grade)
				UnjoinClassUtil.deleteingParticulrGradeObject(scheduleConstraintsObj, dataObj)
			}

		}

		UnjoinClassUtil.updatingTheRulesCount(scheduleConstraintsObj)
	}

	jointClassValidation = () => {
		const i18n = this.props.i18n
		let jointClassExists = false;
		let keys = this.props.keys
		for (let i = 0; i < keys.length; i++) {
			let key = keys[i];
			let dataTableMapObj = this.props.dataTableMap.get(key)
			if (dataTableMapObj.jointClass != undefined) {
				jointClassExists = true;
				let jointClassExistsErrorMsg = StringReplacer.getFormatedMessage(i18n.jointClassConstraints.jointClassExists,
					{
						grade: dataTableMapObj.grade,
						group: dataTableMapObj.group,
					})
				toast(jointClassExistsErrorMsg)
				break;
			}
		}
		return jointClassExists;
	}

	getRandomColor = () => {
		let letters = 'd8ede'.split('');
		let color = '#';
		for (let i = 0; i < 6; i++) {
			color += letters[Math.floor(Math.random() * letters.length)];
		}
		return color;
	}

	render() {
		
		return (
			<JointClassComponent
				{...this.props}
				{...this.state}
				onClickOfSave={this.onClickOfSave}
			/>
		)
	}
}
const mapStateToProps = (state, ownProps) => ({
	updateSchoolinformationInProgress: state.schoolInformation.updateSchoolinformationInProgress,
})
const mapDispatchToProps = (dispatch) => ({
	editSchoolInformation: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(JointClassContainer)